import './PriceList.scss'
import { Helmet } from "react-helmet";
import { constUrlBase } from 'constants/api';

export default function PriceList() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{constUrlBase.bang_gia.title}</title>
        <meta name="description" content={constUrlBase.bang_gia.description} />
      </Helmet>
      <div className="ouwbtcdphd">
        <iframe className='gyarfhtvfn' src="https://trading.dsc.com.vn/dsctrade/priceboard/AAA">
        </iframe>
      </div>
    </>
  )
}